import {
  mainTheme as baseMainTheme,
  getMainTheme as getBaseTheme,
  Themes,
} from '@ankr.com/ui';
import { createTheme } from '@mui/material/styles';

import { getGlobalStyles } from 'uiKit/utils/getGlobalStyles';

import { lightTheme, darkTheme } from './tokens';
import IndeterminateCheckboxIcon from './assets/indeterminateCheckboxIcon.svg?react';

export const getMainTheme = (themes: Themes) => {
  const baseTheme = getBaseTheme(themes) || baseMainTheme || {};
  const tokenTheme = themes === Themes.light ? lightTheme : darkTheme;

  return createTheme({
    ...baseTheme,
    // Merge the palette from tokens.ts with the base theme
    palette: {
      ...tokenTheme.palette,
      ...baseTheme.palette,
      // Ensure custom extensions from tokens are preserved
      border: tokenTheme.palette.border,
      surface: tokenTheme.palette.surface,
      dividerSecondary: tokenTheme.palette.dividerSecondary,
      divider: tokenTheme.palette.divider,
      text: {
        ...tokenTheme.palette.text,
        ...baseTheme.palette?.text,
      },
    },
    components: {
      ...(baseTheme.components || {}),
      MuiCssBaseline: {
        styleOverrides: getGlobalStyles(baseTheme.palette || {}),
      },
      MuiContainer: {
        ...(baseTheme.components?.MuiContainer || {}),
        styleOverrides: {
          ...(baseTheme.components?.MuiContainer?.styleOverrides || {}),
          root: {
            '@media (min-width: 576px)': {
              paddingLeft: 24,
              paddingRight: 24,
            },
            '@media (min-width: 1200px)': {
              paddingLeft: 60,
              paddingRight: 60,
            },
            '&&': {
              maxWidth: '100%',
            },
          },
        },
      },
      MuiPaper: {
        ...(baseTheme.components?.MuiPaper || {}),
        styleOverrides: {
          ...(baseTheme.components?.MuiPaper?.styleOverrides || {}),
          root: {
            backgroundImage: 'none',
            // @ts-ignore
            ...(baseTheme.components?.MuiPaper?.styleOverrides?.root || {}),
          },
        },
      },
      MuiTypography: {
        ...(baseTheme.components?.MuiTypography || {}),
      },
      MuiCheckbox: {
        ...(baseTheme.components?.MuiCheckbox || {}),
        defaultProps: {
          ...(baseTheme.components?.MuiCheckbox?.defaultProps || {}),
          indeterminateIcon: <IndeterminateCheckboxIcon />,
        },
        styleOverrides: {
          ...(baseTheme.components?.MuiCheckbox?.styleOverrides || {}),
          indeterminate: {
            '--indeterminate-checkbox-background':
              tokenTheme.palette.primary?.main ||
              baseTheme.palette?.primary?.main ||
              '#1976d2',
            '--indeterminate-checkbox-sign':
              tokenTheme.palette.background?.paper ||
              baseTheme.palette?.background?.paper ||
              '#ffffff',

            '&:hover': {
              '--indeterminate-checkbox-background':
                tokenTheme.palette.primary?.dark ||
                baseTheme.palette?.primary?.dark ||
                '#1565c0',
            },

            '&.Mui-disabled': {
              '--indeterminate-checkbox-background':
                tokenTheme.palette.divider ||
                baseTheme.palette?.divider ||
                '#e0e0e0',
              '--indeterminate-checkbox-sign':
                tokenTheme.palette.text?.disabled ||
                baseTheme.palette?.text?.disabled ||
                '#9e9e9e',
            },
          },
        },
      },
    },
  });
};

export const mainTheme = getMainTheme(Themes.light);
